<template>
  <v-card flat>
    <v-card-text class="pa-0">
      <div class="py-3 mx-4">
        <v-skeleton-loader
          v-if="loadingOvertime"
          type="table"
          class="mb-4"
        ></v-skeleton-loader>

        <div
          v-else-if="!overtimeRecords || !overtimeRecords.length"
          class="text-center py-8"
        >
          <v-icon size="64" color="grey lighten-1">mdi-calendar-blank</v-icon>
          <div class="text-h6 text-h4 mt-2">沒有加班紀錄</div>
          <div class="text-body-2 text-h4">沒有加班紀錄可以顯示</div>
        </div>

        <template v-else>
          <v-simple-table class="py-3">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">員工</th>
                  <th class="text-left">公司</th>
                  <th class="text-left">開始時間</th>
                  <th class="text-left">結束時間</th>
                  <th class="text-left">加班分鐘</th>
                  <th class="text-left">事由</th>
                  <th class="text-left">是否換補休</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="ot in overtimeRecords" :key="ot.id">
                  <td>
                    {{ ot.user && ot.user.name ? ot.user.name : "-" }}
                  </td>
                  <td>
                    {{
                      ot.company && ot.company.company_name
                        ? ot.company.company_name
                        : "-"
                    }}
                  </td>
                  <td><formatted-date :date="ot.start_time" /></td>
                  <td><formatted-date :date="ot.end_time" /></td>
                  <td>{{ ot.overtime_minutes }}</td>
                  <td>{{ ot.reason || "-" }}</td>
                  <td>{{ ot.is_compensatory_leave ? "是" : "否" }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div class="text-center my-4">
            <v-pagination
              v-model="overtimePage"
              :length="overtimePageCount"
              @input="fetchOvertimeRecords"
              prev-icon="fa fa-angle-left"
              next-icon="fa fa-angle-right"
              color="#cb0c9f"
              circle
            ></v-pagination>
          </div>
        </template>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import FormattedDate from "@/components/FormattedDate.vue";

export default {
  name: "OvertimeRecordsWidget",
  components: {
    FormattedDate,
  },
  props: {
    selectedCompany: {
      type: Object,
      default: () => null,
    },
    targetUserId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      overtimeRecords: [],
      overtimeHeaders: [
        { text: "員工", value: "user.name" },
        { text: "公司", value: "company.company_name" },
        { text: "開始時間", value: "start_time" },
        { text: "結束時間", value: "end_time" },
        { text: "加班分鐘", value: "overtime_minutes" },
        { text: "事由", value: "reason" },
      ],
      overtimePage: 1,
      overtimeItemsPerPage: 15,
      overtimeTotalItems: 0,
      loadingOvertime: false,
      loadingMoreOvertime: false,
      fetchError: false,
      overtimeTotalPages: 1,
    };
  },
  computed: {
    hasMoreOvertime() {
      return this.overtimeRecords.length < this.overtimeTotalItems;
    },
    overtimePageCount() {
      return this.overtimeTotalPages || 1;
    },
  },
  async mounted() {
    await this.fetchOvertimeRecords();
  },
  methods: {
    async fetchOvertimeRecords() {
      this.loadingOvertime = true;

      this.fetchError = false;
      try {
        const params = new URLSearchParams({
          page: this.overtimePage,
          limit: this.overtimeItemsPerPage,
        });
        if (this.selectedCompany && this.selectedCompany.id) {
          params.append("company_id", this.selectedCompany.id);
        }
        if (this.targetUserId) {
          params.append("user_id", this.targetUserId);
        }
        const response = await this.$axios.get(
          `/api/overtime-records?${params}`
        );
        const payload = response && response.data ? response.data : {};
        const newRecords = Array.isArray(payload.data) ? payload.data : [];
        const pagination = payload.pagination || {};
        this.overtimeTotalItems =
          Number(pagination.totalItems) || newRecords.length || 0;
        this.overtimeTotalPages = Number(pagination.totalPages) || 1;

        this.overtimeRecords = newRecords;
      } catch (error) {
        this.overtimeRecords = [];
        this.overtimeTotalItems = 0;
        this.$emit("error", {
          title: "取得加班紀錄失敗",
          message:
            (error && (error.response?.data?.message || error.message)) ||
            "請稍後再試",
        });
        this.fetchError = true;
      } finally {
        this.loadingOvertime = false;
        this.loadingMoreOvertime = false;
      }
    },
  },
};
</script>

<style scoped></style>
